import { render, staticRenderFns } from "./LeftNavigationItem.vue?vue&type=template&id=51213d73&"
import script from "./LeftNavigationItem.vue?vue&type=script&lang=js&"
export * from "./LeftNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigationItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports